
/**
 * EventManager Class
 * 
 * Central event center - Designed as a centralized place to create and remove events
 * 
 * 
 * @class EventManager
 * @constructor
 * @requires moolite 1.0.3+, abstract_manager, list_manager, jquery
 * @type Class
 * 
 */

var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Events = OCS.Events || {};
OCS.Live = OCS.Live || {};
OCS.Classes.OCSEventManager = new Class({
    Implements: [Options, Events],
    class_type: "OCSEventManager",
    class_name: "OCSEventManager",
    options: {
        debug: false
    },
    data_list: null,
    initialize: function (op) {
        this.setOptions(op);
        if (OCS.Live[this.class_name]) {
            return OCS.Live[this.class_name];
        }
        this.data_list = new OCS.Classes.ListManager({debug: this.options.debug});

        OCS.Live[this.class_name] = this;

    },

    /**
     * Subscribe to listen for an event to occur and 
     *      fire back a callback when the event happens.
     * @method subscribe
     * @param {Object} ops Should contain: event_name, callback, and optionaly callback_id, item, selector, context
     * @returns {String}
     */
    subscribe: function (ops) {
        if (ops && typeof ops === "object") {
            var event_obj = new OCS.Classes.OCSEvent(ops);
            var callback_id = event_obj.get_last_callback_id();
            this.data_list.register(callback_id, event_obj);
            return callback_id;
        }
    },

    /**
     * Unsubscribe from listen for an event, removes the callback from being called.
     * @method unsubscribe
     * @param {String} event_callback_id
     */
    unsubscribe: function (event_callback_id) {
        if (this.data_list.is_list_key_in_use(event_callback_id)) {
            var events = this.data_list.get_list_key_elements(event_callback_id);
            events.each(function (event) {
                event.remove_callback(event_callback_id);
            });
        }
    },

    /**
     * Fire off a given event with optional data
     * @method publish
     * @param {String} event
     * @param {Object|String|Number} [data]
     */
    publish: function (event, data) {
        if(OCS.Events[event]) {
            var event_obj = new OCS.Classes.OCSEvent({event_name: event});
            if (!event_obj.options.fire_immediately) {
                event_obj.event(event, data, 1);
            } else {
                event_obj.fireEvent(event, data);
            }
        }
    },
    
    destroy: function () {
        if (this.options.debug) {
            console.debug(this.class_name + ': Removing all events.');
        }
        this.fireEvent('destroy', this);
        this.removeEvents();
        this.$events = {};
        this.data_list = null;
        delete OCS.Live[this.class_name];
    }
});
